import React, { Component } from "react";
import {
  Form,
  FormGroup,
  FormText,
  Label,
  Alert,
  Input,
  Col,
  Button,
  Row,
} from "reactstrap";
import ErrorMessage from "../../../../components/Message/ErrorMessage/ErrorMessage";
import {
  getSubcategories,
  CATEGORY_BEST_PRACTICES,
  CATEGORY_ASSOCIATIONS,
  CATEGORY_CONFERENCES_AND_EVENTS,
  CATEGORY_DIVERSITY_CALENDAR,
  CATEGORY_ERGS,
  CATEGORY_CONSULTANTS,
  CATEGORY_TRAINING_AND_DEVELOPMENT,
  CATEGORY_RECRUITMENT_AND_HIRING,
  CATEGORY_PROGRAMS_AND_INITIATIVES,
  eventBannerImg,
} from "../../../../utils/constants";
import { getCountries } from "../../../../utils/countries";
import { staticTitles } from "../../../../utils/constants";
import "react-datepicker/dist/react-datepicker.css";
import * as url from "../../../../utils/url";
import { getStatesByCountryCode } from "../../../../utils/states";
import DatePicker from "react-datepicker";
import moment from "moment";
import Select from "react-select";
import isEmpty from "lodash/isEmpty";
import axios from "../../../../axios";
import validator from "validator";
import findIndex from "lodash/findIndex";
import CKEditorUI from "../../../../components/CKEditor/CKEditorUI";
import "../AddTool.css";
import "react-datepicker/dist/react-datepicker.css";
import { object } from "prop-types";
// import 'react-select/dist/react-select.css';
import GrpBannerModal from "../../../groups/Components/GrpBannerModal";
import UploadFiles from "../../../../components/UploadFiles/UploadFiles";
import { description } from "platform";
import ItemDescription from "./ItemDescription";
import AutocompleteAddress from "../../../../components/AddressSearch/AutocompleteAddress";

export default class Info extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isBannerOpen: false,
      attachment: this.props.toolDetails.attachment
        ? this.props.toolDetails.attachment
        : "",
      attachments:
        this.props.toolDetails.attachments &&
        this.props.toolDetails.attachments.length > 0
          ? this.props.toolDetails.attachments
          : [],
      isUploadFiles: false,
      original_description:
        this.props.toolDetails &&
        this.props.toolDetails.description &&
        this.props.toolDetails.description.length > 0
          ? this.props.toolDetails.description
          : "",
      original_name:
        this.props.toolDetails && this.props.toolDetails.name
          ? this.props.toolDetails && this.props.toolDetails.name
          : "",
      name: {
        value:
          this.props.toolDetails && this.props.toolDetails.name
            ? this.props.toolDetails && this.props.toolDetails.name
            : "",
        error: false,
      },
      description: {
        value:
          this.props.toolDetails &&
          this.props.toolDetails.description &&
          this.props.toolDetails.description.length > 0
            ? this.props.toolDetails.description
            : " ",
        error: false,
        is_init: true,
      },
      image: {
        value: this.props.toolDetails && this.props.toolDetails.image,
        error: false,
      },
      noOfMembers: {
        value: this.props.toolDetails && this.props.toolDetails.noOfMembers,
        error: false,
      },
      subCategory: this.props.toolDetails && this.props.toolDetails.subCategory,
      startDate:
        this.props.toolDetails && this.props.toolDetails.startDate !== ""
          ? moment(this.props.toolDetails && this.props.toolDetails.startDate)
          : null,
      endDate:
        this.props.toolDetails && this.props.toolDetails.endDate !== ""
          ? moment(this.props.toolDetails && this.props.toolDetails.endDate)
          : null,
      imageUrl: "",
      attachmentUrl: "",
      selectedLocations: {
        countries:
          (this.props.toolDetails &&
            this.props.toolDetails.selectedLocations.countries) ||
          [],
        states:
          (this.props.toolDetails &&
            this.props.toolDetails.selectedLocations.states) ||
          [],
      },
      countriesOptions: getCountries(),
      statesOptions: [],
      references:
        (this.props.toolDetails && this.props.toolDetails.references) || "",
      error: false,
      errors_array: [],
      errorMessage: "",
      bannerImg:
        this.props.toolDetails.bannerImg && this.props.toolDetails.bannerImg
          ? this.props.toolDetails.bannerImg
          : "",
      webinarLink:
        this.props.toolDetails &&
        this.props.toolDetails.webinar &&
        this.props.toolDetails.webinar.link
          ? this.props.toolDetails.webinar.link
          : "",
      ogp:
        this.props.toolDetails &&
        this.props.toolDetails.webinar &&
        this.props.toolDetails.webinar.ogp &&
        Object.keys(this.props.toolDetails.webinar.ogp).length > 0
          ? this.props.toolDetails.webinar.ogp
          : { urlScrape: false, requestUrl: "" },
      eventAddress: this.props.toolDetails.eventAddress || "",
      location: this.props.toolDetails.location || {
        type: "Point",
        coordinates: [0, 0],
      },
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  checkUpdateField = val => {
    // console.log(val, this.props.tool_status)
    if (this.props.tool_status == "Edit") {
      this.props.updateToolFields(val);
    }
  };

  handleChangeToolName = event => {
    const { value } = event.target;
    this.setState({ name: { value } });
    this.checkUpdateField("name");
  };

  handleChangeToolDescription = event => {
    const descriptionContext = event.editor.getData();
    // let{description}=this.state
    this.setState({ description: { value: descriptionContext } });
    this.checkUpdateField("description");
    // if(description.value!=descriptionContext){
    //   this.setState({ description: { value: descriptionContext }})
    // }
  };

  handleChangeToolReference = event => {
    const referenceContext = event.editor.getData();
    this.setState({ references: referenceContext });
    this.checkUpdateField("reference");
  };

  handleChangeToolNoOfMemebers = ({ target }) => {
    if (target.value === "" || validator.isNumeric(target.value)) {
      this.setState({ noOfMembers: { value: target.value }, error: false });
      this.checkUpdateField("noOfMembers");
    }
  };

  handleStartDateChange = date => {
    this.setState({
      startDate: date,
    });
    this.checkUpdateField(["startDate"]);

    // if (this.state.endDate!==null && date > this.state.endDate) {
    //   this.setState({
    //     startDate: this.state.endDate
    //   });
    // } else {
    //   this.setState({
    //     startDate: moment(date)
    //   });
    // }
  };

  handleEndDateChange = date => {
    if (this.state.startDate != null && date < this.state.startDate) {
      this.setState({
        endDate: this.state.startDate,
      });
    } else {
      this.setState({
        endDate: date,
      });
      this.checkUpdateField("endDate");
    }
  };

  handleSubCategorySelected = subCategory => {
    this.setState({ subCategory });
    this.checkUpdateField("subCategory");
  };

  handleCountrySelected = countries => {
    let { statesOptions, selectedLocations } = this.state;
    let { states } = selectedLocations;
    let index = findIndex(countries, { code: "US" });
    if (index !== -1) {
      if (statesOptions.length === 0) {
        statesOptions = getStatesByCountryCode(countries[index].code);
      }
    } else {
      statesOptions = [];
      states = [];
    }
    this.setState({ selectedLocations: { countries, states }, statesOptions });
    this.checkUpdateField("selectedLocations", "statesOptions");
  };

  handleStateSelected = states => {
    let { countries } = this.state.selectedLocations;
    this.setState({ selectedLocations: { countries, states } });
    this.checkUpdateField("selectedLocations");
  };

  handleAddWebinarLink = ({ target }) => {
    let input = target.value;
    this.setState({ webinarLink: input });
    this.checkUpdateField("webinarLink");
  };

  validateToolInfo = () => {
    let infoState = { ...this.state };
    let { toolDetails } = this.props;
    let res = [];
    let result = { ...this.state, ...toolDetails };

    if (
      !infoState.name.value ||
      infoState.name.value === null ||
      infoState.name.value.trim() === ""
    ) {
      // window.scrollTo(0, 0);
      res.push("Name is missing");
      // this.setState({error: false, name: {value: infoState.name.value ,error: true, errorMessage: `Please enter ${staticTitles.toolkit_sm} name`}});
    }

    if (toolDetails.category == "Conferences & Events") {
      if (!infoState.startDate || infoState.startDate == null) {
        res.push("Start date is missing");
      }
      if (!infoState.endDate || infoState.endDate == null) {
        res.push("End date is missing");
      }
    }

    if (infoState.name.value.length > 64) {
      // window.scrollTo(0, 0);
      res.push("Name is too long");
      // this.setState({error: false, name: {value: infoState.name.value, error: true, errorMessage: 'Tool name should be max 30 characters'}});
    }
    if (
      !infoState.description.value ||
      infoState.description.value === null ||
      infoState.description.value.trim() === ""
    ) {
      // window.scrollTo(0, 0);
      res.push("Description is missing");
      // this.setState({error: false, description: {value: infoState.description.value, error: true, errorMessage: `Please enter ${staticTitles.toolkit_sm} description`}});
    }
    if (!infoState.description.value.length > 1000) {
      // window.scrollTo(0, 0);
      res.push("Description is too long");
      // this.setState({error: false, description: {value: infoState.description.value, error: true, errorMessage: `${staticTitles.toolkit_lg} description should be max 1000 characters`}});
    }
    if (infoState.startDate > infoState.endDate) {
      // window.scrollTo(0, 0);
      res.push("Start date should not be greater than end date");
      // this.setState({error: true, errorMessage: `${staticTitles.toolkit_lg}  start date should not greater than end date.`});
    }
    if (
      infoState.noOfMembers &&
      infoState.noOfMembers.value !== "" &&
      Number(infoState.noOfMembers.value) < 0
    ) {
      res.push("Members count should be a valid number");
      // this.setState({noOfMembers: {error: true, errorMessage: `${staticTitles.toolkit_lg}  number of members should be valid number'`}});
    }
    if (infoState.bannerImg == null || infoState.bannerImg == "") {
      res.push("Image is missing");
      // this.setState({error: true, errorMessage: `Please select or upload an image for this event.`});
    }

    this.setState({ errors_array: res });

    if (res.length == 0) {
      let localState = { ...this.state };
      localState.name = localState.name.value;
      localState.webinar = { link: this.state.webinarLink };
      localState.description = localState.description.value;
      if (
        localState.startDate &&
        localState.startDate != "" &&
        localState.startDate != null
      ) {
        localState.startDate = localState.startDate;
      } else {
        delete localState.startDate;
      }
      if (
        localState.endDate &&
        localState.endDate != "" &&
        localState.endDate != null
      ) {
        localState.endDate = localState.endDate;
      } else {
        delete localState.endDate;
      }
      delete localState.error;
      delete localState.errorMessage;
      localState.image = this.state.bannerImg;
      localState.bannerImg = this.state.bannerImg;
      localState.attachments = this.state.attachments;
      // if(this.state.original_description!= localState.description.value){
      //   this.checkUpdateField('description')
      // }
      // if(this.state.original_name != localState.name){
      //   this.checkUpdateField('name')
      // }

      if (localState.noOfMembers.value && localState.noOfMembers.value !== "") {
        localState.noOfMembers = localState.noOfMembers.value;
      } else {
        delete localState.noOfMembers;
      }
      delete localState.countriesOptions;
      delete localState.statesOptions;
      // console.log('local---', localState)
      this.props.onCompleted({ ...localState });
    }
  };

  // Trigger datepicker on calender icon
  openDatePicker = id => {
    document.getElementById(id).click();
  };

  getFileNameFromS3Path = path => {
    // console.log(path)
    if (path !== undefined && path && path !== null) {
      let fileNameArray = path.split("/");
      return fileNameArray[fileNameArray.length - 1];
    }
  };

  returnSiteName = () => {
    let { ogp } = this.state;
    let { ogUrl, twitterAppNameGooglePlay, ogSiteName, requestUrl } = ogp;
    if (ogSiteName) {
      return ogSiteName;
    } else if (twitterAppNameGooglePlay) {
      return twitterAppNameGooglePlay;
    } else {
      let urlName = ogUrl ? ogUrl : requestUrl;
      let startNameURL = urlName.indexOf("w.") + 2;
      let endNameURL = urlName.indexOf(".com");
      let startEndDiff = endNameURL - startNameURL;
      let siteName = urlName.substr(startNameURL, startEndDiff);
      if (siteName.indexOf("http") == -1) {
        return siteName;
      } else {
        return ogUrl;
      }
    }
  };

  setUploads = attachments => {
    this.setState({ attachments });
    this.checkUpdateField("attachments");
  };

  removeOldAttachment = () => {
    this.setState({ attachment: "" });
    this.checkUpdateField("attachment");
  };

  openBannerModal = () => {
    this.setState(prevState => ({
      isBannerOpen: !prevState.isBannerOpen,
    }));
  };

  setBannerImg = bannerImg => {
    // console.log('baner--- ', bannerImg)
    this.setState({ bannerImg });
    this.checkUpdateField("bannerImg");
  };

  removeBannerImg = () => {
    this.setState({ bannerImg: null });
    this.checkUpdateField("bannerImg");
  };

  removeOgp = () => {
    this.setState({
      ogp: {
        urlScrape: false,
      },
    });
    this.checkUpdateField("ogp");
  };

  handleSelect = (address, longitude, latitude) => {
    this.setState({
      eventAddress: address,
      location: {
        type: "Point",
        coordinates: [longitude, latitude],
      },
    });
    this.checkUpdateField("eventAddress");
    this.checkUpdateField("location");
  };

  render() {
    let {
      name,
      description,
      isUploadFiles,
      image,
      attachment,
      startDate,
      bannerImg,
      isBannerOpen,
      webinarLink,
      endDate,
      noOfMembers,
      subCategory,
      countriesOptions,
      statesOptions,
      attachments,
      errors_array,
      ogp,
      selectedLocations,
      references,
      error,
      errorMessage,
      imageUrl,
      eventAddress,
    } = { ...this.state };

    let { urlScrape, ogImage, ogUrl, ogDescription, ogTitle } = ogp;

    countriesOptions = countriesOptions.filter(
      country => country.code !== "ALL"
    );
    let { countries, states } = selectedLocations;
    let { category } = this.props.toolDetails;
    let alert = null;
    let subCategorySection = null;
    let noOfMembersSection = null;
    let subCategories = getSubcategories(category);
    if (states.length > 0 && statesOptions.length === 0) {
      let index = findIndex(countries, { code: "US" });
      if (index !== -1) {
        if (statesOptions.length === 0) {
          statesOptions = getStatesByCountryCode(countries[index].code);
        }
      }
    }
    let startDatePicker = null;
    let endDatePicker = null;
    if (error) {
      alert = <ErrorMessage message={errorMessage} />;
    }
    if (category === CATEGORY_ASSOCIATIONS || category === CATEGORY_ERGS) {
      noOfMembersSection = (
        <FormGroup row>
          <Col sm={2} className="text-right">
            <div className="text-right addToolLabel">Number of Members</div>
            <div className="focus-instruction ">(optional)</div>
          </Col>
          <Col sm={5} className="align-self-center">
            <Input
              type="number"
              name="noOfMembers"
              id="noOfMembers"
              className="input-custom"
              value={noOfMembers.value}
              onChange={this.handleChangeToolNoOfMemebers}
              min="0"
              placeholder="e.g. 25"
              invalid={noOfMembers.error}
            />
            {noOfMembers.error ? (
              <div className="input-error-msg-field">
                {noOfMembers.errorMessage}
              </div>
            ) : null}
          </Col>
        </FormGroup>
      );
    }

    if (
      category === CATEGORY_ERGS ||
      category === CATEGORY_CONFERENCES_AND_EVENTS ||
      category === CATEGORY_PROGRAMS_AND_INITIATIVES ||
      category === CATEGORY_TRAINING_AND_DEVELOPMENT
    ) {
      startDatePicker = (
        <FormGroup row>
          <Col sm={2} className="text-right">
            <div className="text-right addToolLabel">
              Start and <br />
              End Date
            </div>
            {category === CATEGORY_CONFERENCES_AND_EVENTS ? <div></div> : <div className="focus-instruction ">(optional)</div> } 
          </Col>
          <Col sm={4} md={4} className="align-self-center">
            <div className="inner-addon right-addon">
              <span
                className="tool-start-date flaticon-calendar"
                onClick={() => this.openDatePicker("startDatePicker")}
              ></span>
              <DatePicker
                //  showTime={{ use12Hours: true }}
                placeholderText="Select start date"
                className="input-custom-date form-control"
                id="startDatePicker"
                selectsStart
                autoComplete={"off"}
                showTimeSelect
                timeFormat={"h:mm a"}
                timeCaption="time"
                dateFormat={"MM/DD/YYYY h:mm a"}
                selected={startDate}
                onChange={date => this.handleStartDateChange(date)}
                startDate={startDate}
                endDate={endDate}
                minDate={moment()}
              />
            </div>
          </Col>
          <Col sm={4} md={4} className="align-self-center">
            <div className="inner-addon right-addon">
              <span className="tool-end-date">
                <span
                  className="flaticon-calendar"
                  onClick={() => this.openDatePicker("endDatePicker")}
                />
              </span>
              <DatePicker
                // showTime={{ use12Hours: true }}
                placeholderText="Select end date"
                className="input-custom-date form-control"
                id="endDatePicker"
                selectsEnd
                autoComplete={"off"}
                showTimeSelect
                timeFormat={"h:mm a"}
                timeCaption="time"
                dateFormat={"MM/DD/YYYY h:mm a"}
                selected={endDate}
                minDate={startDate ? startDate : moment()}
                onChange={date => this.handleEndDateChange(date)}
                startDate={startDate}
                endDate={endDate}
                disabled={!this.state.startDate}
              />
            </div>
          </Col>
        </FormGroup>
      );
    }

    if (subCategories.length > 0) {
      subCategorySection = (
        <FormGroup row>
          <Col sm={2} md={2} className="text-right">
            <div className="text-right addToolLabel">Subcategory</div>
            <div className="focus-instruction ">(optional)</div>
          </Col>
          <Col sm={5} md={5}>
            <Select
              name="category-select"
              placeholder={"Select a subcategory"}
              value={subCategory}
              onChange={subCategory =>
                this.handleSubCategorySelected(subCategory)
              }
              options={subCategories}
              valueKey="subCategoryKey"
              labelKey="subCategoryValue"
              getOptionLabel={({ subCategoryValue }) => subCategoryValue}
              getOptionValue={({ subCategoryKey }) => subCategoryKey}
            />
          </Col>
        </FormGroup>
      );
    }

    return (
      <Form>
        {alert}
        <FormGroup>
          <div className="toolkit_add_tool_image_container">
            <span
              onClick={() => this.openBannerModal()}
              className="grp_create_page_bannerImg_txt"
            >
              {" "}
              Change image{" "}
            </span>
            <img
              onClick={() => this.openBannerModal()}
              src={
                bannerImg != null && bannerImg.url
                  ? bannerImg.url
                  : eventBannerImg
              }
              className={`grp_create_page_bannerImg ${
                bannerImg == null ? "banner_filter" : "boxShadow1"
              }`}
            />
          </div>
        </FormGroup>
        <FormGroup row>
          <Label htmlFor="toolName" sm={2} className="text-right addToolLabel">
            Name
          </Label>
          <Col sm={9} className="align-self-center">
            <div className="inner-addon right-addon">
              <span className="name-hint-max-length name-char-count-txt">
                {name.value.length}/64
              </span>
              <Input
                type="text"
                name="toolName"
                className="input-custom toolkitAddToolName"
                value={name.value}
                id="toolName"
                maxLength="64"
                onChange={this.handleChangeToolName}
                placeholder="Provide the current name, or write a short distinct name for a new resource"
                invalid={name.error}
              />
            </div>
            {name.error ? (
              <div className="input-error-msg-field">{name.errorMessage}</div>
            ) : null}
          </Col>
        </FormGroup>

        {startDatePicker}

        <FormGroup row>
          <Label
            htmlFor="description"
            sm={2}
            className="text-right addToolLabel"
          >
            Description
          </Label>
          <Col sm={9}>
            <div
              className={description.error === true ? "emptyDescription" : ""}
            >
              <CKEditorUI
                onChange={this.handleChangeToolDescription}
                value={description.value}
                afterPaste={this.addText}
              />
            </div>

            {description.error ? (
              <div className="input-error-msg-field">
                {description.errorMessage}
              </div>
            ) : null}
          </Col>
        </FormGroup>

        <FormGroup row>
          <Col sm={2} className="text-right">
            <div className="text-right addToolLabel">Attachment</div>
            <div className="focus-instruction ">(optional)</div>
          </Col>
          <Col sm={9}>
            <UploadFiles
              isToolkit={true}
              actionType="Edit"
              attachments={attachments}
              limit={5}
              old_attachment={this.state.attachment}
              removeOldAttachment={this.removeOldAttachment}
              setUploads={this.setUploads}
            />
          </Col>
        </FormGroup>

        <FormGroup row>
          <Col sm={2} className="text-right">
            <div className="text-right addToolLabel">Add webinar link</div>
            <div className="focus-instruction ">(optional)</div>
          </Col>
          <Col sm={8}>
            <Input
              type="text"
              name="toolName"
              className="input-custom toolkitAddToolName"
              value={webinarLink}
              id="toolName"
              onChange={this.handleAddWebinarLink}
              onKeyPress={e => {
                e.key === "Enter" && e.preventDefault();
              }}
              placeholder="Provide a webinar link or online link to tune into"
              // invalid={name.error}
            />
          </Col>

          {urlScrape ? (
            <div className="ogPreviewCreateContainer">
              <span
                className="removeOgpPreview flaticon-trash"
                onClick={this.removeOgp}
              />

              <div className="ogPreviewContainer">
                {ogImage && ogImage.url ? (
                  <img src={ogImage.url} className="ogPreviewImage" />
                ) : (
                  <span></span>
                )}
                <span className="ogPreviewContent">
                  <span className="ogPreviewSite">
                    <a href={ogUrl} target="_blank">
                      {this.returnSiteName()}
                    </a>
                  </span>
                  <span className="ogPreviewTitle">{ogTitle}</span>
                  {ogDescription && ogDescription.length > 0 ? (
                    <span className="ogp_description_item">
                      {ogDescription}
                    </span>
                  ) : null}
                </span>

                {/* <span>{ogDesc}</span> */}
                {/* , ogDesc, ogTitle, ogType, ogUrl, ogSiteName */}
              </div>
            </div>
          ) : null}
        </FormGroup>

        {subCategorySection}

        {noOfMembersSection}
        {/* {startDatePicker}   
        {endDatePicker} */}
        <FormGroup row>
          <Col sm={2} className="text-right">
            <div className="text-right addToolLabel">Locations</div>
            <div className="focus-instruction ">(optional)</div>
          </Col>
          <Col sm={3}>
            <Select
              name="country-select"
              placeholder={"Select"}
              value={countries}
              onChange={countries => this.handleCountrySelected(countries)}
              options={countriesOptions}
              valueKey="code"
              labelKey="name"
              getOptionLabel={({ name }) => name}
              getOptionValue={({ code }) => code}
              multi
            />
          </Col>
          {statesOptions.length > 0 && (
            <Col sm={3}>
              <Select
                name="state-select"
                placeholder={"Select"}
                value={states}
                onChange={states => this.handleStateSelected(states)}
                options={statesOptions}
                valueKey="abbreviation"
                labelKey="name"
                getOptionLabel={({ name }) => name}
                getOptionValue={({ abbreviation }) => abbreviation}
                multi
              />
            </Col>
          )}
        </FormGroup>

        <FormGroup row>
          <Col sm={2} className="text-right">
            <div className="text-right addToolLabel">Event Address</div>
            <div className="focus-instruction ">(optional)</div>
          </Col>
          <Col sm={9}>
            <AutocompleteAddress
              address={eventAddress}
              handleSelect={this.handleSelect}
            />
          </Col>
        </FormGroup>
        {category === CATEGORY_BEST_PRACTICES && (
          <FormGroup row>
            <Col htmlFor="references" sm={2} className="text-right ">
              <div className="addToolLabel">References</div>
              <div className="focus-instruction ">(optional)</div>
            </Col>
            <Col sm={9}>
              <CKEditorUI
                onChange={this.handleChangeToolReference}
                value={references}
              />
            </Col>
          </FormGroup>
        )}

        {errors_array.length > 0 ? (
          <Alert className="toolkit_add_page_errors_container" color="danger">
            Please fill in the following:
            <ul>
              {" "}
              {errors_array.map((e, idx) => {
                return (
                  <li className="toolkit_add_page_errors" key={idx}>
                    {e}
                  </li>
                );
              })}
            </ul>
          </Alert>
        ) : null}

        <FormGroup className="toolkitAddContinueBtnContainer">
          <Button className="continueBtn" onClick={this.validateToolInfo}>
            <span className="continueBtnTxt">
              Continue <span className="ml10 flaticon-next"></span>
            </span>
          </Button>
        </FormGroup>

        <GrpBannerModal
          from_module="toolkit"
          removeBannerImg={this.removeBannerImg}
          setBannerImg={this.setBannerImg}
          image={bannerImg}
          openBannerModal={this.openBannerModal}
          isBannerOpen={isBannerOpen}
        />
      </Form>
    );
  }
}
